var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgThumbnailDefault1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 64,
    viewBox: "0 0 112 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "w1aoop1g2a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1368 0v1600H0V0h1368z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "xnw0uqduwb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 0v64H0V0h112z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4b9nknwsuc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.333 10.667A2.667 2.667 0 0 1 15 15.415v11.149c-.544.067-1.099.102-1.661.103h-.01c-.564 0-1.118-.036-1.662-.103V15.415a2.667 2.667 0 0 1 1.667-4.748zm0-10.667c7.364 0 13.334 5.97 13.334 13.333 0 6.092-4.086 11.23-9.667 12.823V22.64a10.004 10.004 0 0 0 6.333-9.307c0-5.523-4.477-10-10-10s-10 4.477-10 10c0 4.229 2.625 7.844 6.334 9.307v3.516C4.086 24.563 0 19.426 0 13.333 0 5.97 5.97 0 13.333 0zm0 5.333A8 8 0 0 1 17 20.445V16.22a4.667 4.667 0 1 0-7.333 0v4.225a8 8 0 0 1 3.667-15.112z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-64-876h1368V724H-64z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w1aoop1g2a)",
    transform: "translate(-64 -876)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xnw0uqduwb)",
    transform: "translate(64 876)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5858D3",
    d: "M0 0h112v64H0V0z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4b9nknwsuc)",
    transform: "translate(42.667 18.667)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h26.667v26.667H0V0z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgThumbnailDefault1);
export default __webpack_public_path__ + "static/media/img-thumbnail-default-1.269c6e7ea68cfd34e6886c2d446793bd.svg";
export { ForwardRef as ReactComponent };